import { activeCommentAtom, Comment } from "@app/shared/atoms/comments-atom";
import { Button } from "@design-system/ui/button";
import { userAtom } from "@framework/config/atoms";
import { trans, plainTrans } from "@mongez/localization";
import { PenIcon } from "lucide-react";

type CommentActionProps = {
  comment: Comment;
  type: string;
  typeId: number;
};

export function CommentAction({ comment, type, typeId }: CommentActionProps) {
  const user = userAtom.useValue();

  if (user.id !== comment.createdBy?.id) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={plainTrans("editComment")}
      title={plainTrans("editComment")}
      className="h-8 w-8 rounded-full text-slate-400 hover:bg-slate-100 hover:text-primary dark:hover:bg-slate-800"
      onClick={() => {
        activeCommentAtom.update(comment);
      }}
    >
      <PenIcon size={15} />
    </Button>
  );
}
